<template>
  <div>
    Display Active Users Here...
  </div>
</template>

<script>
export default {
  name: 'ActiveUsers',
  data: function () {
    return {
    }
  },
  computed: {
  },
  methods: { },
}
</script>

<style lang="scss" scoped>
</style>
